// src/pages/PDFViewerPage.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSecureMedia } from '../services/mediaService';
import { Loader } from 'lucide-react';

const PDFViewerPage = () => {
    const location = useLocation();
    
    const { fileUrl, mediaId, title } = location.state || {};
    const displayTitle = title || 'سند PDF';

    // اگر mediaId داریم، لینک امن دریافت کن
    const { mediaUrl, isLoading, error } = useSecureMedia(mediaId || null);
    const pdfUrl = fileUrl || mediaUrl;

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-64 text-gray-600">
                <Loader size={32} className="animate-spin ml-2" />
                <span>در حال دریافت فایل...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center py-10 text-red-500">
                <p className="font-bold">خطا در دریافت فایل</p>
                <p className="text-sm">{error}</p>
            </div>
        );
    }

    if (!pdfUrl) {
        return (
            <div className="text-center py-10 text-gray-500">
                <p>فایلی برای نمایش وجود ندارد</p>
            </div>
        );
    }

    return (
        <div className="flex flex-col h-full">
            {/* عنوان کوچک (اختیاری) */}
            <h1 className="text-lg font-bold text-gray-800 mb-3 px-2">{displayTitle}</h1>
            
            {/* کانتینر PDF با ارتفاع کامل */}
            <div className="flex-1 relative border border-gray-200 rounded-lg overflow-hidden" style={{ minHeight: '70vh' }}>
                <embed 
                    src={pdfUrl} 
                    type="application/pdf" 
                    className="absolute inset-0 w-full h-full"
                />
            </div>
        </div>
    );
};

export default PDFViewerPage;